import { userProfileConstants } from '../../_constants';
import { userProfileService } from '../../_services';

export const userProfileAction = {
    getUserProfileHandler
};

function getUserProfileHandler() {
    return dispatch => {
        dispatch(request());
        userProfileService.getUserProfileHandler()
            .then(
                getUserProfile => {
                    if (getUserProfile.data.user.length) {
                        localStorage.setItem('user_name', getUserProfile.data.user[0].short_name)
                        localStorage.setItem('gender', getUserProfile.data.user[0].gender);
                    }
                    dispatch(success(getUserProfile));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userProfileConstants.REQUEST_USER_PROFILE } }

    function success(getUserProfile) { return { type: userProfileConstants.RECEIVE_USER_PROFILE, getUserProfile } }

    function failure(error) { return { type: userProfileConstants.USER_PROFILE_ERROR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/UserProfile/getUserProfile.action.js